<template>
  <div
    :class="{
      'logo w-[170px] shrink-0 md:w-[150px] lg:h-[47px] lg:w-[216px]': true,
    }"
  >
    <div
      :class="{
        'mr-0 md:mr-3': true,
      }"
    >
      <GeneralLink
        _type="generalLink"
        :link="logoLink"
        text=""
        data-component-name="logo-home"
        aria-label="Home"
      >
        <PtcPicture
          v-if="logo.asset"
          provider="sanity"
          :src="logo.asset?._ref"
          alt="Logo"
          :quality="75"
          :loading="'eager'"
          :preload="true"
          :img-attrs="{
            class: { ' mx-auto w-full xl:h-[43px]': true },
          }"
        />
      </GeneralLink>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { EducationHeader } from '~/sanity/types';
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';

defineProps<EducationHeader>();
</script>

<style lang="scss">
.logo .internal-link {
  display: inline !important;
}
</style>
